import client from "./internal/httpClient";

const captchApi = {}

captchApi.get = function (data) {
    return client.post("/door-client/captcha.php", data)
}

export default captchApi